import React from 'react';

import { FormattedMessage } from 'react-intl';

import { getTrackingStatusMessage } from '../../../../components/tracking-status-indicator';
import { TrackingStatusLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

const TrackingStatus = () => {
  const { trackingStatus } = useFulfillmentDisplayContext();

  const statusMessageDescriptor = getTrackingStatusMessage(trackingStatus);

  return <ReadonlyField label={TrackingStatusLabel}>{trackingStatus && <FormattedMessage {...statusMessageDescriptor} />}</ReadonlyField>;
};

export default TrackingStatus;
